import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";
import { cacheResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from 'kea-resource';
import { CargaZE } from "./cargaze";


const controller = rpcController("DescargaZE");

const otros = {

    /**Incluye un conjunto de guías en una DescargaZE */
    IncluirGuiasSeleccionadas: async (idGuias: number[], idDescargaZE: number): Promise<models.LecturaFolioFisico> => await controller('IncluirGuiasSeleccionadas', { idGuias: idGuias, idDescargaZE: idDescargaZE }),

    /**Escanea y agrega un folio fisico a una DescargaZE */
    EscanearFolio: async (folioFisico: string, idDescargaZE: number): Promise<models.LecturaFolioFisico> => await controller('EscanearFolio', { folioFisico, idDescargaZE }),

    /**Obtiene el resumen de una CargaZE */
    ObtenerResumen: async (idDescargaZE: number): Promise<models.ResumenCargaDescarga> => await controller('ObtenerResumen', { idDescargaZE }),

    /**Inicia un proceso de descarga para la ZE */
    IniciarDescargaZE: async (idChoferZE: number): Promise<number> => await controller('IniciarDescargaZE', { idChoferZE }),

    /**Obtiene todos los servicios pendientes de acompletar una guia en una DescargaZE */
    ObtenerServiciosPendientes: async (idDescargaZE: number): Promise<models.PendientesCargaDescarga> => await controller('ObtenerServiciosPendientes', { idDescargaZE }),

    /**Quita de la DescargaZE un servicio incompleto */
    QuitarServicioIncompleto: async (idDescargaZE: number, idServicio: number, numeroFisico: number, tipo: models.TipoFolioFisico): Promise<void> => await controller('QuitarServicioIncompleto', { idDescargaZE, idServicio, numeroFisico, tipo }),

    /**Obtiene todas las guias en una DescargaZE */
    ObtenerGuiasEnDescargaZE: async (idDescargaZE: number): Promise<models.GuiaDTO[]> => await controller('ObtenerGuiasEnDescargaZE', { idDescargaZE }),

    /**Quita una guia de una DescargaZE */
    QuitarGuia: async (idDescargaZE: number, idGuia: number): Promise<void> => await controller('QuitarGuia', { idDescargaZE, idGuia }),

    /**Borra una DescargaZE */
    Delete: async (id: number): Promise<void> => await controller('Delete', { id }),

    /**Obtiene una DescargaZEDTO */
    Get: async (id: number): Promise<models.DescargaZEDTO> => await controller('Get', { id }),

    /**Obtiene todas las entidades  */
    Query: async (): Promise<models.DescargaZEDTO[]> => await controller('Query', {}),
}

export const DescargaZE = cacheResource({
    ...otros
}, {
        Query: true,
        Get: true,
    }, {
        IniciarDescargaZE: true,
        EscanearFolio: true,
        QuitarGuia: true,
        QuitarServicioIncompleto: true,
        IncluirGuiasSeleccionadas: true
    })

addOnInvalidateHandler(DescargaZE, () => invalidateResource(CargaZE));



// WEBPACK FOOTER //
// ./app/resources/items/descargaze.ts